// Wraps your existing PrivateRoute
import React from "react";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import PrivateRoute from "./PrivateRoute";

const RegistrationAwarePrivateRoute = (props) => {
  const { isInRegistration, steps, currentStepIndex } = useSelector(
    (state) => state.registration
  );

  if (isInRegistration) {
    return <Redirect to={steps[currentStepIndex]} />;
  }

  return <PrivateRoute {...props} />;
};

export default RegistrationAwarePrivateRoute;
